<template>
    <div class="user-agreement">
        <h2>服务说明及用户协议</h2>

        <section>
            <h3>一、服务定义</h3>
            <p>“一键解绑”服务（以下简称“本服务”）指手机号码用户查询接入的互联网企业及应用，并可申请清理该号码下非本人注册的互联网应用的服务，以改善用户在互联网应用注册服务体验。</p>
        </section>

        <section>
            <h3>二、服务开通和内容</h3>
            <p>2.1 用户协议（以下简称“本协议”）是北京北纬通信科技股份有限公司（以下简称“我方”）与用户（以下简称“您”）就“一键解绑”服务所订立的合约。本协议对双方具有同等法律约束力。请您务必审慎阅读、充分理解本协议中各项条款内容，特别是粗体标注的内容。您一旦通过网络页面点击同意或以其他方式确认本协议，即表明您已了解并完全同意本协议各项内容，本协议即成立并生效，您自愿接受并遵守本协议的全部约定。如您不同意本协议任何内容，请不要以同意本协议的形式（如点击同意本协议、签字确认等）进行下一步操作或使用本服务。您可停止使用“一键解绑”服务。</p>
            <p>2.2 无法正常使用手机号码注册互联网应用的我方在网用户（不含港澳台地区）可申请本服务。申请服务过程中，请您依照提示正确填写开户人姓名、开户证件信息、手机号码、验证码等信息，并确保其真实性、准确性和合法性。号码机主认证通过后，请您确认系统提示的号码开户时间或自行填写号码开户时间（以下简称“开户时间”）。确认后，您可自行勾选申请清理的具体互联网企业或应用。</p>
            <p>2.3 目前本服务暂不支持携号转入/转出的用户申请。</p>
            <p>2.4 您授权我方收集您填写或确认的信息为：开户人姓名、开户证件信息、手机号码（包含您选择的同一开户证件下关联的其他号码，下同）、开户时间、申请清理的具体互联网企业或应用，当手机号码机主认证通过后，您将进一步授权我方将您的手机号码、开户时间提供给您申请清理的具体互联网企业或应用。</p>
            <p>2.5 您申请清理的互联网企业或应用，将依据您手机号码的开户时间与注册互联网应用时间进行验证比对，并按以下规则处理：</p>
            <p>（1）开户时间早于注册时间的，属于正常注册，互联网企业或应用不做清理。</p>
            <p>（2）开户时间晚于注册时间的，互联网企业将清理该手机号码现有的注册信息，并允许该手机号码注册新账户。</p>
            <p>您申请清理的互联网企业或应用将上述处理结果同步反馈给我方。</p>
            <p>2.6 我方为您提供“一键解绑”服务结果查询。</p>
            <p>2.7 为向您提供本服务，我方将严格遵循合法、正当、必要和诚信原则，对基于本协议授权而获取的您的个人信息严格保密，并依法采取必要的技术措施和安全措施妥善保管，未经您同意不会在本服务范围以外使用。本协议解除或终止后，我方将停止收集您的个人信息，并将按照相关法律法规规定的要求对本协议存续期间收集的信息进行妥善处理。</p>
        </section>

        <section>
            <h3>三、免责事由和不可抗力</h3>
            <p>3.1 请您仔细核对办理本服务填写的全部信息，确保其真实、准确、完整；因您填写信息错误导致“一键解绑”服务失败或产生其他不利后果的，相关责任由您自行承担。</p>
            <p>3.2 您理解并同意，如因非可归因于我方的原因（如第三方系统故障、互联网企业信息保护措施不当、您提供的信息有误等）导致“一键解绑”服务失败的，您需自行承担可能产生的不利后果。</p>
            <p>3.3 不可抗力是指：不能预见、不能避免且不能克服的客观情况，如台风、洪水、地震等自然灾害；鉴于互联网之特殊性质，本协议所称不可抗力亦包括黑客攻击、电信部门技术调整导致之重大影响、因政府管制而造成之暂时关闭、病毒侵袭等影响互联网正常运行之情形。</p>
            <p>3.4 因不可抗力导致本协议部分或全部不能履行的，应及时通知对方并采取合理措施减少损失，双方可部分或全部免除责任。</p>
        </section>

        <section>
            <h3>四、争议解决方式</h3>
            <p>双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均可向北京市海淀区人民法院提起诉讼。</p>
        </section>

        <section>
            <h3>五、联系我们</h3>
            <p>官方客服电话：4001-99-4001</p>
        </section>
    </div>
</template>

<script>
export default {
    name: "SecondNumberRefreshUserAgreement",
}
</script>

<style lang="scss" scoped>
.user-agreement {
    height: px2rem(820);
    max-height: 60vh;
    padding: px2rem(28);
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: px2rem(10);
    background: #f7f9fb;
    color: #344154;
    line-height: px2rem(42);
    -webkit-overflow-scrolling: touch;

    h2 {
        margin-bottom: px2rem(24);
        text-align: center;
        color: #172333;
        font-size: px2rem(30);
        font-weight: 600;
    }

    h3 {
        margin: px2rem(24) 0 px2rem(12);
        color: #1f74cf;
        font-size: px2rem(26);
        font-weight: 600;
    }

    p {
        margin-bottom: px2rem(14);
        font-size: px2rem(24);
        text-align: justify;
    }

    section:first-of-type h3 {
        margin-top: 0;
    }
}
</style>
